import axios from "axios";

let keycloakInstance = null;

export const setKeycloak = (keycloak) => {
 keycloakInstance = keycloak;
};

const apiClient = axios.create({
 baseURL: process.env.REACT_APP_API_BASE_URL,
 headers: {
 "Content-Type": "application/json",
 },
});

apiClient.interceptors.request.use(async (config) => {
 if (keycloakInstance) {
 try {
 // Refresh the token if it expires within 30 seconds
 await keycloakInstance.updateToken(30);
 } catch (err) {
 // Refresh token itself has expired — force re-login
 console.warn("Token refresh failed — redirecting to login");
 keycloakInstance.login();
 return Promise.reject(new Error("Session expired"));
 }

 config.headers.Authorization = `Bearer ${keycloakInstance.token}`;
 }

 return config;
});

// Handle 401 responses (e.g. token rejected server-side)
apiClient.interceptors.response.use(
 (response) => response,
 async (error) => {
 if (error.response && error.response.status === 401 && keycloakInstance) {
 try {
 await keycloakInstance.updateToken(-1); // force refresh
 // Retry the original request with the new token
 error.config.headers.Authorization = `Bearer ${keycloakInstance.token}`;
 return apiClient.request(error.config);
 } catch (refreshErr) {
 console.warn("Token refresh on 401 failed — redirecting to login");
 keycloakInstance.login();
 }
 }
 return Promise.reject(error);
 }
);

export default apiClient;
